import { type ReactNode } from 'react';
import { Flex, Icon, Text } from '@servicetitan/anvil2';
import { useProviderConfig } from '@servicetitan/financing-workflow-shared';
import Warning from '@servicetitan/anvil2/assets/icons/material/round/warning.svg';
import { declinedWarningBox } from './DeclinedWarningBox.module.scss';

interface DeclinedWarningBoxProps {
    message?: ReactNode;
}

export const DeclinedWarningBox = ({ message }: DeclinedWarningBoxProps) => {
    const providerConfig = useProviderConfig();
    const displayMessage = message ?? providerConfig.declinedMessage;

    if (!providerConfig.declinedHeadline && !displayMessage) {
        return null;
    }

    return (
        <Flex gap="3" alignItems="flex-start" className={declinedWarningBox}>
            <Icon
                svg={Warning}
                style={{
                    color: '#FFBE00',
                }}
                size="large"
            />
            <Flex direction="column" gap="1">
                {providerConfig.declinedHeadline && (
                    <Text variant="body" size="medium">
                        <strong>{providerConfig.declinedHeadline}</strong>
                    </Text>
                )}
                {displayMessage && <Text variant="body">{displayMessage}</Text>}
            </Flex>
        </Flex>
    );
};
